import axios from '../../../services/axios';


export async function generateValidateInformation ({client, companyId}) {
    try{
        console.warn('DADOS DO CLIENTE:', client);

        const res = await axios.post(`/smartmenu/validate/information/generate`, {
            client: JSON.stringify(client),
            companyId: companyId,
        })

        if(res.status == 201){
            return res.data.code;
            
        } else {
            throw new Error();
        }


    } catch (e) {
        console.error('ERROR - GENERATE VALIDATE IFORMATION FUNCTION:', e);
        throw e;
    }
}